import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Link from "../../../../LinkWithCountry/LinkWithCountry";
import AddressSelector from "../AddressSelector/AddressSelector";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from "../../../../../shared/utilities/amplitude";
import endpoints from "../../../../../shared/constants/endpoints";
import styles from "../NavigationBar.module.css";
import {
  getDesktopLogo,
  getMobileLogo,
  getNavPartProps,
  isNavigationBarBrandRefresh,
} from "../navigationBarBrandRefreshClasses";

const legacyDesktopLogo = require("../../../imgs/logo-horizontal-stacked.png");
const legacyMobileLogo = require("../../../imgs/app-logo.png");
const brandRefreshDesktopLogo = require("../../../imgs/brand-refresh-app-logo-new.svg");
const brandRefreshMobileLogo = require("../../../imgs/brand-refresh-logo-new.svg");
const brandRefreshOrdersDot = require("../NavIcons/imgs/brand-refresh-OrdersDot.svg");

const LeftSide = ({
  isLoggedIn,
  userOrderMethod,
  selectedStore,
  userAddress,
  onToggleHeaderWidget,
  hasActiveOrders,
}) => {
  const location = useLocation();
  const isBrandRefresh = isNavigationBarBrandRefresh();
  const desktopLogo = getDesktopLogo(legacyDesktopLogo, brandRefreshDesktopLogo);
  const mobileLogo = getMobileLogo(legacyMobileLogo, brandRefreshMobileLogo);

  const trackNavClick = (navElement) => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement,
      navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
      pathname: location.pathname,
    });
  };

  const navLinks = [
    { label: "Find a Bakery", to: endpoints.locations },
    { label: "Gifting", to: endpoints.gifting },
    { label: "Shipping", to: endpoints.shippingPage },
    ...(isLoggedIn
      ? [{ label: "Orders", to: endpoints.orders }]
      : [{ label: "Insomnia Rewards", to: endpoints.rewardLandingPage }]),
  ];

  return (
    <div
      className={
        isBrandRefresh
          ? styles.leftSide
          : `${styles.leftSide} flex items-center flex-shrink-0`
      }
      data-part={getNavPartProps("left-side")}
    >
      <Link
        to="/"
        name="home_page_link"
        className={styles.headerLogo}
        onClick={() => trackNavClick("Home")}
      >
        <img
          src={mobileLogo}
          alt=""
          className={`${styles.logoMobile} block md:hidden`}
          data-part={getNavPartProps("logo-mobile")}
        />
        {isBrandRefresh ? (
          <span
            className={`${styles.logoDesktop} hidden md:flex`}
            data-part={getNavPartProps("logo-desktop")}
          >
            <img src={desktopLogo} alt="" />
          </span>
        ) : (
          <img
            src={desktopLogo}
            alt=""
            className={`${styles.logoDesktop} hidden md:block`}
          />
        )}
      </Link>

      {!isBrandRefresh && (
        <div className="flex md:hidden">
          <AddressSelector
            userOrderMethod={userOrderMethod}
            selectedStore={selectedStore}
            userAddress={userAddress}
            onToggleHeaderWidget={onToggleHeaderWidget}
          />
        </div>
      )}

      <div
        className={
          isBrandRefresh
            ? `${styles.navLinksContainer} hidden md:flex`
            : `${styles.navLinksContainer} hidden md:flex items-center gap-5`
        }
        data-part={getNavPartProps("nav-links-container")}
      >
        {navLinks.map((link) => {
          const isOrdersLink = link.label === "Orders";
          return (
            <Link
              key={link.to + link.label}
              to={link.to}
              id={isOrdersLink ? "ordersPageLink" : undefined}
              className={
                isOrdersLink
                  ? `${styles.navLink} ${styles.ordersLink}`
                  : styles.navLink
              }
              onClick={() => trackNavClick(link.label)}
              data-part={getNavPartProps("nav-link")}
            >
              {link.label}
              {isOrdersLink && hasActiveOrders && (
                isBrandRefresh ? (
                  <img
                    src={brandRefreshOrdersDot}
                    alt=""
                    className={styles.ordersAttentionGrabber}
                    data-part={getNavPartProps("orders-attention-grabber")}
                    aria-hidden="true"
                  />
                ) : (
                  <span
                    className={styles.ordersAttentionGrabber}
                    data-part={getNavPartProps("orders-attention-grabber")}
                    aria-hidden="true"
                  />
                )
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

LeftSide.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  userOrderMethod: PropTypes.string,
  selectedStore: PropTypes.shape({
    name: PropTypes.string,
  }),
  userAddress: PropTypes.shape({
    address1: PropTypes.string,
    savedLocation: PropTypes.shape({
      locationLabel: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }),
  onToggleHeaderWidget: PropTypes.func.isRequired,
  hasActiveOrders: PropTypes.bool,
};

LeftSide.defaultProps = {
  userOrderMethod: "",
  selectedStore: null,
  userAddress: null,
  hasActiveOrders: false,
};

export default LeftSide;
